import jwt_decode from "jwt-decode";
import { NSBNAuth } from "../types";
export var isUser = function (user) {
    return (user.bn_role === NSBNAuth.BNRole.User ||
        user.bn_role === NSBNAuth.BNRole.Admin);
};
export var isAdmin = function (user) {
    return user.bn_role === NSBNAuth.BNRole.Admin;
};
export var validateUserAccessToken = function (user) {
    var exp = jwt_decode(user.accessToken).exp;
    var currDate = new Date();
    var diffSeconds = Math.floor(exp - currDate.getTime() / 1000);
    return diffSeconds > 0 ? diffSeconds : 0;
};
//# sourceMappingURL=validators.js.map